import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {TwoLine} from 'shells/two-line/two-line';

import type {SalesAutomationStageGoal as SalesAutomationStageGoalFragment} from 'nutshell-graphql-types';

import {getGoalIconForType} from '../../constants';

import {SalesAutomationCard} from './sales-automation-card';

type Props = {
    goal: SalesAutomationStageGoalFragment;
    isHidden: boolean;
    parentId: string;
};

export class SalesAutomationCardGoal extends React.PureComponent<Props> {
    render() {
        const GoalIcon = getGoalIconForType(this.props.goal.goalType);

        return (
            <SalesAutomationCard
                type='goals'
                borderColor={colors.green}
                isHidden={this.props.isHidden}
                parentId={this.props.parentId}
                entityId={this.props.goal.id}
            >
                <TwoLine
                    icon={GoalIcon}
                    iconSize={20}
                    topRow={this.props.goal.humanReadableTitle}
                    bottomRow={this.props.goal.humanReadableSubtitle}
                    isLargeWithSmallBottomRow={true}
                />
            </SalesAutomationCard>
        );
    }
}
